"use client";

// src/utils/use-outside-interaction.ts
import { useEffect } from "react";
function useOutsideInteraction(refs, callback, { active = true } = { active: true }) {
  useEffect(() => {
    if (!active) return;
    const handleClickOutside = (event) => {
      if (refs.every(
        (ref) => ref.current && !ref.current.contains(event.target)
      )) {
        callback();
      }
      return;
    };
    const abortController = new AbortController();
    document.addEventListener("click", handleClickOutside, {
      signal: abortController.signal
    });
    document.addEventListener("focusin", handleClickOutside, {
      signal: abortController.signal
    });
    return () => {
      abortController.abort();
    };
  }, [refs, callback, active]);
}
export {
  useOutsideInteraction
};
